export class Task {
    id = 0;
    list_id = 0;
    name = '';
    description = '';
    status = 0;
}
